export const flavorAtlas = [
  {
    id: "sweet",
    name: "焦糖甜香",
    icon: "ri-cake-3-line",
    desc: "以焦糖、黑糖、奶香为主调，入口圆润，适合作为一盒零食的收尾。",
    examples: "海盐焦糖曲奇、黑糖脏脏包、麦丽素",
  },
  {
    id: "salty",
    name: "咸香醇厚",
    icon: "ri-bowl-line",
    desc: "咸度与油脂香结合，耐吃且不容易腻，是多数盲盒里占比最高的一类。",
    examples: "咸蛋黄酥、厚切薯片、肉松卷",
  },
  {
    id: "spicy",
    name: "麻辣辛香",
    icon: "ri-fire-line",
    desc: "辣椒与花椒共同作用，先辣后麻，香气在咀嚼中层层释放，适合重口味。",
    examples: "麻辣锅巴、藤椒薯片、魔芋爽",
  },
  {
    id: "sour",
    name: "酸爽清口",
    icon: "ri-leaf-line",
    desc: "靠果酸与柠檬提味，解腻醒神，常被安排在吃了甜食之后。",
    examples: "柠檬气泡糖、陈皮话梅、酸角糕",
  },
  {
    id: "nutty",
    name: "坚果焙香",
    icon: "ri-plant-line",
    desc: "烘焙带来的焦香与油脂香，颗粒感强，分量更容易控制。",
    examples: "蜂蜜黄油杏仁、炭烤腰果、混合坚果",
  },
  {
    id: "retro",
    name: "怀旧奶香",
    icon: "ri-time-line",
    desc: "带着年代感的奶香与糖香，口味朴素直接，一拆就想起旧时小卖部。",
    examples: "麦丽素、话梅糖、无花果丝",
  },
];